// extracted by mini-css-extract-plugin
export default {"support-card":"Card_support-card__jK6Yn","item":"Card_item__vcQRI","icon-box":"Card_icon-box__FqwwJ","content":"Card_content__QzJdh","method":"Card_method__+zN+j"};